<template>
    <v-row class="expert-list-item">
        <v-col cols="auto">
            <v-avatar width="18rem" height="12rem" tile color="grey lighten-4">
                <v-img v-if="expert._avatar" :src="expert.avatar.url" :alt="`${expert.companyName} 로고`" contain />
                <v-icon v-else-if="isOrganization" size="4rem">mdi-domain</v-icon>
                <v-icon v-else-if="isSupporter" size="4rem">mdi-account</v-icon>
            </v-avatar>
        </v-col>
        <v-col class="expert-item-texts">
            <item-area-badges :areas="expert.areas" />
            <div v-if="expert.companyName" class="text-h6 line-height-1">{{ expert.companyName }}</div>
            <div v-if="expert.nickname" class="text-h6 line-height-1">{{ expert.nickname }}</div>
            <div v-if="expert.summary" class="expert-item-summary">{{ expert.summary }}</div>
            <data-list :dataList="description" isOnList :disableNoneMessage="isSupporter" />
        </v-col>
        <v-col cols="auto">
            <v-btn :href="href" outlined color="primary" class="rounded-0">상세보기</v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/data/CONSTANTS";
import DataList from "./data-list.vue";
import ItemAreaBadges from "./item-area-badges.vue";
export default {
    components: { ItemAreaBadges, DataList },
    props: ["expert"],
    computed: {
        isOrganization() {
            return this.expert?.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.expert?.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
        description() {
            const items = [];

            if (this.isOrganization) {
                const { ceoName, establishedAt, workerName, workerTitle, phone, email, website } = this.expert;

                if (ceoName) items.push({ term: "대표자", description: ceoName });
                if (establishedAt) items.push({ term: "설립일", description: establishedAt.toDate() });
                if (workerName) items.push({ term: "담당자", description: `${workerName} ${workerTitle}` });
                if (phone) items.push({ term: "연락처", description: phone });
                if (email) items.push({ term: "이메일", description: email });
                if (website) items.push({ term: "홈페이지", description: website });
            }

            if (this.isSupporter) {
            }

            return items;
        },
        href() {
            if (this.isOrganization) return `/experts/organization/${this.expert?._id}`;
            if (this.isSupporter) return `/experts/individual/${this.expert?._id}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.expert-list-item {
    margin: 2rem auto;
}
.expert-item-texts {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    > * {
        flex: 0 0 auto;

        &:not(:last-child) {
            margin-bottom: 1rem;
        }
    }
}
.expert-item-summary {
    font-size: 0.9rem;
    color: grey;
}
</style>
